export default "__VITE_ASSET__Cv1_k8XU__"